import SchoolRepositories from "@repositories/school.repository"
import { Result } from "./result"
import { School, SchoolListQuery, SchoolType } from "@interfaces/school"
import { PaginationData } from "@interfaces/misc"

export default class SchoolServices extends SchoolRepositories {
  async getSchoolList(type: SchoolType, query?: Partial<SchoolListQuery>) {
    try {
      const res = await this.getRawSchoolList(type, {
        page: query?.page ?? 1,
        limit: query?.limit ?? 12,
        ...(query?.search && { search: query?.search }),
      })
      const response = await this._getResponse<PaginationData<School>>(res)

      if (response.error) {
        return Result.fail<PaginationData<School>>()
      }

      return Result.ok<PaginationData<School>>(response.result)
    } catch (e) {
      return Result.fail<PaginationData<School>>()
    }
  }
}
